import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import './Container.scss';

/**
 * Container.
 */
const propTypes = {
  size: PropTypes.string, // xl, lg, md, sm, xl
}
const Container = React.forwardRef( ( { className: customClass, size, ...p }, ref ) => {

  const className = classnames(
    'Container',
    'container-fluid',
    customClass,
    {
      [`is-${size}`]: !! size,
    }
  )

  return(

    <div
    ref={ ref }
    className={ className }
    { ...p }
    >
      { p.children }
    </div>

  )

} );
Container.propTypes = propTypes;

export default Container;